package com.tedd.db

import kotlin.Long
import kotlin.String

public data class User_profile(
  public val id: String,
  public val fullname: String,
  public val email: String,
  public val avatar_url: String,
  public val bio: String,
  public val language: String,
  public val theme_mode: String,
  public val finance_default_period: String,
  public val finance_default_currency: String,
  public val pomodoro_focus_min: Long,
  public val pomodoro_short_break_min: Long,
  public val pomodoro_long_break_min: Long,
  public val notify_habits: Long,
  public val notify_deadlines: Long,
  public val notify_pomodoro_end: Long,
  public val notify_budget_alerts: Long,
  public val created_at: Long,
  public val updated_at: Long,
  public val is_deleted: Long,
  public val deleted_at: Long?,
  public val synced_at: Long?,
)
